import React, { useEffect, useState } from 'react';

type ToasterProps = {
	title: string;
	message: string;
	isVisible: boolean;
};

const Toaster = React.forwardRef<HTMLDivElement, ToasterProps>(
	({ title, message, isVisible }, ref) => {
		const [fadeClass, setFadeClass] = useState('');

		useEffect(() => {
			if (isVisible) {
				setFadeClass('toaster-fade-in'); // Apply fade-in effect
			} else {
				setFadeClass('toaster-fade-out'); // Apply fade-out effect
			}
		}, [isVisible]);

		return (
			<div ref={ref} id="toaster" className={`toaster ${fadeClass}`}>
				<div className="toaster-content">
					<div className="toaster-title">{title}</div>
					<div className="toaster-message">{message}</div>
				</div>
			</div>
		);
	}
);

export default Toaster;
